export default {
  data: () => ({
    searchCategory: 1,
    page: 1,
    pageLength: 1,
    searchItems: [
      { searchText: "차수", searchValue: 1 },
      { searchText: "부위", searchValue: 2 },
      { searchText: "동", searchValue: 3 },
      { searchText: "층", searchValue: 4 },
      { searchText: "부재", searchValue: 5 },
    ],
    searchWord: "",
    searchDateCategory: "",
  }),
  computed: {
    roleType() {
      return this.$store.getters.getUserList.roleType;
    },
  },
  created() {
    let path = this.$router.currentRoute.fullPath;
    if (
      (this.roleType == "시스템관리자" || this.roleType == "현장관리자") &&
      (path == "/order" || path == "/invoice")
    ) {
      this.searchItems.push({
        searchText: "샵업체",
        searchValue: 6,
      });
      this.searchItems.push({
        searchText: "가공업체",
        searchValue: 7,
      });
    }
    if (path == "/invoice" || path == "/store") {
      this.searchItems.push({
        searchText: "송장번호",
        searchValue: 8,
      });
    }
  },
};
